var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 16,
    height: 16,
    viewBox: "-1 -1 19 19",
    fill2: "#8A8F98",
    className: "sc-oVeUv keolNh",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.00003C4.58172 1.00003 1 4.58175 1 9.00003C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9.00003C17 4.58175 13.4183 1.00003 9 1.00003ZM0 9.00003C0 4.02947 4.02944 3.05176e-05 9 3.05176e-05C13.9706 3.05176e-05 18 4.02947 18 9.00003C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9.00003Z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9.00003C18 4.02947 13.9706 2.95639e-05 9 2.95639e-05C4.02944 2.95639e-05 0 4.02947 0 9.00003C0 13.9706 4.02944 18 9 18Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12.2502C10.6575 12.2502 12 10.9077 12 9.25015C12 7.59265 10.6575 6.25015 9 6.25015C7.3425 6.25015 6 7.59265 6 9.25015C6 10.9077 7.3425 12.2502 9 12.2502ZM9 13.7502C6.9975 13.7502 3 14.7552 3 16.7502V17.5002C3 17.9127 3.3375 18.2502 3.75 18.2502H14.25C14.6625 18.2502 15 17.9127 15 17.5002V16.7502C15 14.7552 11.0025 13.7502 9 13.7502Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.84fedd2d.svg";
export { ForwardRef as ReactComponent };